<template>
  <!-- Density toggle (data-table rule 03): a user control in the surface's top bar / card title -->
  <span class="density-toggle" role="radiogroup" aria-label="Row density">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :title="option.title"
      :aria-pressed="String(value === option.value)"
      @click.stop="$emit('input', option.value)">
      <v-icon :size="16">{{ option.icon }}</v-icon>
    </button>
  </span>
</template>

<script>
  import { DENSITIES, DENSITY_OPTIONS, isDensity } from './densityPreference';

  export default {
    name: 'DensityToggle',
    props: {
      value: { type: String, default: DENSITIES.DEFAULT, validator: isDensity },
    },
    data() {
      return { options: DENSITY_OPTIONS };
    },
  };
</script>

<style lang="scss" scoped>
  .density-toggle {
    display: inline-flex;
    border: 1px solid var(--aa-border-default);
    border-radius: var(--ds-radius-sm);
    overflow: hidden;

    button {
      width: 30px;
      height: 28px;
      border: none;
      border-right: 1px solid var(--aa-border-default);
      background: var(--aa-surface);
      color: var(--aa-text-secondary);
      cursor: pointer;
      display: grid;
      place-items: center;

      .v-icon { color: inherit !important; }
      &:last-child { border-right: none; }
      &:focus-visible { outline: 2px solid var(--aa-focus); outline-offset: -2px; }
      &[aria-pressed='true'] { background: var(--aa-brand); color: #fff; }
    }
  }
</style>
